import { useState } from 'react';
import { Button } from '@mantine/core';

import { useGetOrganisationFeatureAccess } from 'hooks';
import type { OrganisationType } from 'types';

import { CompanyDataSettingsModal } from './CompanyDataSettingsModal';

type Props = {
  organisation: OrganisationType;
};

export const CompanyDataSettings = ({ organisation }: Props) => {
  const { isAdministrator } = organisation;
  const [modalOpened, setModalOpened] = useState(false);
  const { data: hasEmailCustomizationFeature } =
    useGetOrganisationFeatureAccess('emailCustomization');

  const allCompanyDataFieldsEmpty = Object.values(organisation.details).every(
    value => value === null || value === '',
  );

  if (!isAdministrator || !hasEmailCustomizationFeature) return null;

  return (
    <>
      <Button variant="default" onClick={() => setModalOpened(true)}>
        {allCompanyDataFieldsEmpty ? 'Dodaj' : 'Edytuj'}
      </Button>
      <CompanyDataSettingsModal
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        organisation={organisation}
      />
    </>
  );
};
